import React from "react";
import { ErrorMessage, Field, Formik } from "formik";
import {
  Alert,
  Form,
  Card,
  Row,
  Col,
  Accordion,
  Button,
} from "react-bootstrap";
import AlertError from "../../../components/AlertError";
import { update } from "../../services/hospitalizationcrud";

export const MedicalDataAdditional = (props) => {
  return (
    <>
      <Card>
        <Card.Header>
          <Accordion.Toggle
            as={Button}
            variant="link"
            eventKey={props.eventKey}
          >
            Informacion Medica Adicional
          </Accordion.Toggle>
          <i className={`fa ${props.icon}`} style={{position:"absolute", right:"0", marginRight:"15px", marginTop:"10px" }}></i>
        </Card.Header>
        <Accordion.Collapse eventKey={props.eventKey}>
          <Card.Body>
            <ContentMedicalDataAdditional {...props} />
          </Card.Body>
        </Accordion.Collapse>
        
      </Card>
    </>
  );
};

export const ContentMedicalDataAdditional = (props) => {
  return (
    <>
      <Alert
        variant="dark"
        className="text-center mt-4"
        style={{ fontSize: "14px" }}
      >
        Informacion Medica Adicional
      </Alert>

      <Card>
        <Card.Body>
          <FormMedicalDataAdditional {...props} />
        </Card.Body>
      </Card>
    </>
  );
};

export const FormMedicalDataAdditional = (props) => {
  const { disabled = false, bindSubmitForm } = props;
  const { id } = props.data;

  const handleSubmitForm = async (values, { setStatus, setSubmitting }) => {
    await update(values, id).then((response) =>
      console.log("Form medical data additional inside saved")
    );
  }
  return (
    <Formik initialValues={{ additionalMedicInformation: props.data.additionalMedicInformation }} onSubmit={handleSubmitForm} enableReinitialize={true}>
      {({
        values,
        errors,
        touched,
        handleChange,
        handleSubmit,
        status,
        isSubmitting,
        submitForm,
      }) => {
        bindSubmitForm(submitForm);
        return (
          <>
            <AlertError status={status} />
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col>
                  <Form.Group>
                    <div role="group" aria-labelledby="checkbox-group">
                      <label className="mr-5">
                        <Field
                          className="mr-1"
                          disabled={disabled}
                          name="additionalMedicInformation"
                          value="Nota de Evolución"
                          type="checkbox"
                          onChange={handleChange}
                        />
                        Nota de Evolución
                      </label>
                      <label className="mr-5">
                        <Field
                          className="mr-1"
                          disabled={disabled}
                          name="additionalMedicInformation"
                          value="Fecha de Diagnostico"
                          type="checkbox"
                          onChange={handleChange}
                        />
                        Fecha de Diagnostico
                      </label>
                      <label className="mr-5">
                        <Field
                          className="mr-1"
                          disabled={disabled}
                          name="additionalMedicInformation"
                          value="Estudios que confirme Dx"
                          type="checkbox"
                          onChange={handleChange}
                        />
                        Estudios que confirme Dx
                      </label>
                      <label className="mr-5">
                        <Field
                          className="mr-1"
                          disabled={disabled}
                          name="additionalMedicInformation"
                          value="Estudios de Lab/Gabinete"
                          type="checkbox"
                          onChange={handleChange}
                        />
                        Estudios de Lab/Gabinete
                      </label>
                      <label className="mr-5">
                        <Field
                          className="mr-1"
                          disabled={disabled}
                          name="additionalMedicInformation"
                          value="Nota Posquirurgica"
                          type="checkbox"
                          onChange={handleChange}
                        />
                        Nota Posquirurgica
                      </label>
                      <label className="mr-5">
                        <Field
                          className="mr-1"
                          disabled={disabled}
                          name="additionalMedicInformation"
                          value="Hisotira Clinica"
                          type="checkbox"
                          onChange={handleChange}
                        />
                        Historia Clínica
                      </label>
                      <label className="mr-5">
                        <Field
                          className="mr-1"
                          disabled={disabled}
                          name="additionalMedicInformation"
                          value="Resumen Medico Actual"
                          type="checkbox"
                          onChange={handleChange}
                        />
                        Resumen Medico Actual
                      </label>
                      <label className="mr-5">
                        <Field
                          className="mr-1"
                          disabled={disabled}
                          name="additionalMedicInformation"
                          value="Aviso de Accidente"
                          type="checkbox"
                          onChange={handleChange}
                        />
                        Aviso de Accidente
                      </label>
                      <label className="mr-5">
                        <Field
                          className="mr-1"
                          disabled={disabled}
                          name="additionalMedicInformation"
                          value="Informe Medico Actualizado"
                          type="checkbox"
                          onChange={handleChange}
                        />
                        Informe Medico Actualizado
                      </label>
                      <label className="mr-5">
                        <Field
                          className="mr-1"
                          disabled={disabled}
                          name="additionalMedicInformation"
                          value="Denuncia ante MP"
                          type="checkbox"
                          onChange={handleChange}
                        />
                        Denuncia ante MP
                      </label>
                    </div>
                    <ErrorMessage name="enough_letter_without_name">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  Nota: Cualquier otro Estudio o Documento Especializado Favor de Especificarlo en la Bitacora de Comentarios.
                </Col>
              </Row>
            </Form>
          </>
        );
      }}
    </Formik>
  );
};
